import type { Rotina } from '@/services/api/rotinas';
import { DIAS_SEMANA, proximaData } from './rotinaUtils';

type Estado = { rotulo: string; dot: string };

/** O que o dia faz na materialização das 20h da véspera: no ar, nada (mas tem molde guardado), ou nada mesmo. */
export const estadoDoDia = (doDia: Rotina[]): Estado => {
    if (doDia.some((e) => e.ativa)) return { rotulo: 'No ar', dot: 'bg-emerald-500' };
    if (doDia.length > 0) {
        return {
            rotulo: `${doDia.length} desligada${doDia.length > 1 ? 's' : ''}`,
            dot: 'bg-amber-500',
        };
    }
    return { rotulo: 'Sem rotina', dot: 'bg-muted-foreground/40' };
};

export default function DiasPills({ rotinas, selecionado, proximoDia, onSelecionar }: {
    rotinas: Rotina[];
    selecionado: number;
    /** Dia da semana que a próxima materialização vai processar. */
    proximoDia: number;
    onSelecionar: (dia: number) => void;
}) {
    return (
        <nav aria-label="Dias da semana" className="grid grid-cols-4 gap-2 sm:grid-cols-7">
            {[0, 1, 2, 3, 4, 5, 6].map((dia) => {
                const doDia = rotinas.filter((e) => e.dia_semana === dia);
                const { rotulo, dot } = estadoDoDia(doDia);
                const sel = dia === selecionado;
                return (
                    <button
                        key={dia}
                        type="button"
                        aria-pressed={sel}
                        onClick={() => onSelecionar(dia)}
                        className={`flex min-h-[88px] flex-col items-start gap-1.5 rounded-xl border p-3 text-left transition-colors ${
                            sel ? 'border-foreground bg-foreground text-background' : 'bg-card hover:bg-accent'
                        }`}
                    >
                        <span className="flex w-full items-center justify-between gap-1">
                            <span className="text-sm font-semibold">{DIAS_SEMANA[dia]}</span>
                            {dia === proximoDia && (
                                <span className={`rounded-full px-1.5 py-px text-[10px] font-semibold ${
                                    sel ? 'bg-background text-foreground' : 'bg-amber-100 text-amber-900'
                                }`}>
                                    Próxima
                                </span>
                            )}
                        </span>
                        <span className="text-xs tabular-nums opacity-75">{proximaData(dia)}</span>
                        <span className="inline-flex items-center gap-1.5 text-xs font-medium">
                            <span className={`h-2 w-2 rounded-full ${dot}`} />
                            {rotulo}
                        </span>
                    </button>
                );
            })}
        </nav>
    );
}
